import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { useCustomIntl } from '../../../../i18n/i18n';
import { ChapterSubHeadline } from '../chapterComponents/ChapterSubHeadline';

export const ServicesRepairAndMaintenanceChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const headlineImage = getImageAssetWithLocale(
    imageKeys.servicesRepairAndMaintenance1,
    locale,
  );

  const subImage = getImageAssetWithLocale(
    imageKeys.servicesRepairAndMaintenance2,
    locale,
  );

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={
            'userManual.chapter.services.repairAndMaintenance.headline'
          }
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.chapter.services.repairAndMaintenance.text'}
          />
          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={headlineImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.services.repairAndMaintenance.headline',
              })}
              enlargeable
            />
          </div>
        </div>
        <ChapterSubHeadline
          messageId={
            'userManual.chapter.services.repairAndMaintenance.subHeadline'
          }
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <div className="display-flex col-xs-12 col-md-6 gap-10 flex-column padding-0">
            <ChapterText
              messageId={
                'userManual.chapter.services.repairAndMaintenance.subText1'
              }
              externalLink="https://www.man.eu/mobile24"
            />
            <ChapterText
              className="text-size-12"
              messageId={
                'userManual.chapter.services.repairAndMaintenance.subText2'
              }
            />
          </div>

          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={subImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.services.repairAndMaintenance.subHeadline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
    </div>
  );
};
